import template from "./bCreateSettlement.html";
import moment from "moment";

export function bCreateSettlementDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bCreateSettlementController,
    controllerAs: 'bCreateSettlement',
    bindToController: true,
    scope: {
      employeeData: "=",
      showModal: "=",
      userSettlement: "=?",
      canEdit: "=",
      overtimeApplication: "=?",
      refreshAfterAllocation: "&?",
      isManagementView: "=?"
    },
  };

  return directive;
}

class bCreateSettlementController {
  constructor(API, Stats, Notes, bModal, $translate, $scope, $interval, $filter, $rootScope, OvertimeApplications) {
    'ngInject';

    this.Notes = Notes;
    this.bModal = bModal;
    this.API = API;
    this.Stats = Stats;
    this.$translate = $translate;
    this.$filter = $filter;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$interval = $interval;
    this.expiresAt = "";
    this.annualObjects = [];
    this.employeeView = false;
    this.allData = "";
    this.disableButton = false;
    this.showErrorDate = false;
    this.data = "";
    this.employee = "";
    this.fifoValue = "00:00:00";
    this.fifoValueToShow = "00:00:00";
    this.cumulatedOvertimeToShow = "00:00:00";
    this.changedFifoValue = false;
    this.durationInvalidFifo = false;
    this.displayedObjects = [];
    this.sort = {};
    this.OvertimeApplications = OvertimeApplications;
    this.from = moment().startOf('month');
    this.to = moment().endOf('month');

    this.shareHeaders = [
      { name: this.$translate.instant("OVERTIME.MODAL.DATE"), class: "table-short", sort: "year" },
      {
        name: this.$translate.instant("OVERTIME.MODAL.OVER_TIME_BALANCE"),
        class: "table-short",
        sort: "cumulatedOvertime"
      },
      { name: this.$translate.instant("OVERTIME.MODAL.ACCEPTED_TIME_BALANCE"), class: "table-short", sort: "validFrom" },
      { name: this.$translate.instant("OVERTIME.MODAL.WORKLOGS_ACCEPTED"), class: "table-short", sort: "validUntil" },
      { name: this.$translate.instant("OVERTIME.MODAL.USED_OVERTIMES"), class: "table-short" },
      { name: this.$translate.instant("OVERTIME.MODAL.COMMENT"), class: "table-short", sort: "comment" },
      { id: "actions", name: null, class: "table-actions" },
    ];
    this.state = "loading";
  }

  init() {
    var timeout = this.$interval(() => {
      this.notes = this.Notes.getNotes();
    }, 10);
    this.$scope.$on("$destroy", () => {
      this.$interval.cancel(timeout);
    });

    this.state = "loading";
    this.callData();
  }

  callData() {
    if (this.userSettlement) {
      this.getEditData();
    }
    else {
      if (this.overtimeApplication) {
        this.getCreateDataForApplications();
      }
      else
        this.getCreateData();
    }
  }

  getCreateData() {
    this.Stats.createSettlementView(this.employee.id, this.isManagementView).then(res => {
      this.allData = {
        ...res.data.settlementCreateView,
        cumulatedOvertime: moment.duration(res.data.settlementCreateView.cumulatedOvertime),
      };
      this.cumulatedOvertimeToShow = this.$filter("hms")(this.allData.cumulatedOvertime.toJSON());
      if (moment.duration(res.data.settlementCreateView.cumulatedOvertime)._milliseconds < 0) {
        this.disableButton = true;
      }

      const settles = res.data.settlementCreateView.settles.map((x) => {
        return {
          ...x,
          settledOvertime: moment.duration(),
          settledOvertimeToShow: this.$filter("hms")(moment.duration().toJSON())
        };
      }).sort((a, b) => new Date(b.acceptedOvertimeDate) - new Date(a.acceptedOvertimeDate));

      let settlesPreviousYears = {
        ...this.allData.settlesPreviousYears,
        workTime: "",
        worknorm: {
          worknorm: ""
        },
        overtimeAlreadyUsed: this.allData.settlesPreviousYears.overtimeAlreadyUsed,
        acceptedOvertimeDate: "OVERTIME.CUMULATED_FROM_PREVIOUS_YEARS",
        settledOvertime: moment.duration(),
        settledOvertimeToShow: this.$filter("hms")(moment.duration().toJSON())
      };
      this.fifoValue = this.allData.cumulatedOvertime;
      this.fifoValueToShow = this.$filter("hms")(this.allData.cumulatedOvertime.toJSON());

      settles.push(settlesPreviousYears);
      this.settlesObjects = settles.reverse();
      this.displayedObjects = angular.copy(this.settlesObjects);

      this.state = "loaded";
    }, () => {
      this.state = "error";
    });
  }

  getCreateDataForApplications() {
    this.OvertimeApplications.getAllocations(this.employeeData.id).then(res => {
      this.items = res.data.items;
      const workdayTimes = res.data.workdayTimes;

      this.settlesObjects = workdayTimes.map(workdayTime => {
        const existingItem = this.items.find(item => item.date === workdayTime.date);

        return {
          ...workdayTime,
          acceptedOvertimeDate: workdayTime.date,
          settledOvertime: moment.duration(),
          settledOvertimeToShow: this.$filter("hms")(moment.duration().toJSON()),
          alreadyFilled: existingItem
            ? moment.duration(existingItem.settledOvertime).toJSON()
            : moment.duration().toJSON()
        };
      }).sort((a, b) => new Date(a.acceptedOvertimeDate) - new Date(b.acceptedOvertimeDate));

      this.fifoValue = this.items.length > 0
        ? this.items.reduce(
          (accumulator, current) => accumulator.subtract(moment.duration(current.settledOvertime)),
          moment.duration(this.employeeData.reportedDuration)
        )
        : moment.duration(this.employeeData.reportedDuration);

      this.fifoValueToShow = this.$filter("hms")(this.fifoValue.toJSON());
      this.cumulatedOvertimeToShow = this.$filter("hms")(this.fifoValue.toJSON());
      this.displayedObjects = angular
        .copy(this.settlesObjects)
        .filter(settleObject => moment(settleObject.date).isBetween(this.from, this.to, undefined, '[]'));

      this.isNotWorknormBased = res.data.position !== 'Worknorm';
      this.useFifoDisabled = this.isNotWorknormBased
        || this.displayedObjects.every(settleObject => moment.duration(settleObject.reportedOvertime).add(moment.duration(settleObject.alreadyFilled)) >= 0);
      
      this.state = "loaded";
    }, () => {
      this.state = "error";
    });
  }

  saveEditSettlement() {
    let settleFromPreviousYears = this.displayedObjects.filter(x => {
      if (x.acceptedOvertimeDate === "OVERTIME.CUMULATED_FROM_PREVIOUS_YEARS") {
        return x;
      }
    })[0];

    let settles = this.displayedObjects.filter(x => {
      if (x.acceptedOvertimeDate !== "OVERTIME.CUMULATED_FROM_PREVIOUS_YEARS") {
        x.settledOvertime = moment.duration(x.settledOvertime).toJSON();
        return x;
      }
    });
    const saveObject = {
      date: this.allData.date,
      settles: settles,
      comment: this.allData.comment,
      settleFromPreviousYears: moment.duration(settleFromPreviousYears.settledOvertime).toJSON()
    };

    this.Stats.saveEditSettlement(this.userSettlement.id, saveObject, this.isManagementView).then(() => {
      this.closeModal();
      this.Notes.postNote({
        type: "success",
        message: this.$translate.instant("VIEW360.MODAL.SUCCESS_SAVED")
      });
    }, (res) => {
      this.modalConfig = {
        text: res.data.message,
        acceptText: this.$translate.instant("OK"),
        cancelText: "",
        hideLeftButton: "hide"
      };

      this.bModal.show(this.modalConfig).then(() => {
      }, (res) => {
        this.Notes.postNote({
          type: "error",
          message: res.data
        });
      });
    }, angular.noop);

    setTimeout(this.init(), 300);
  }

  saveOvertimeApplicationSettlement() {
    this.state = "loading";
    const data = this.displayedObjects
      .filter(object => moment.duration(object.settledOvertimeToShow).asMilliseconds() > 0 || object.alreadyFilled !== 'P0D')
      .map(object => ({date: object.date, allocatedOvertime: moment.duration(object.settledOvertime).add(moment.duration(object.alreadyFilled))}));

    this.OvertimeApplications.saveAllocation(this.employeeData.id, data).then(
      () => {
        this.closeModal();
        this.Notes.postNote({
          type: "success",
          message: this.$translate.instant("VIEW360.MODAL.SUCCESS_ALLOCATION")
        });

        this.refreshAfterAllocation();
      }, (res) => {
        this.modalConfig = {
          text: res.data.message,
          acceptText: this.$translate.instant("OK"),
          cancelText: "",
          hideLeftButton: "hide"
        };
  
        this.bModal.show(this.modalConfig).then(() => {
        }, (res) => {
          this.Notes.postNote({
            type: "error",
            message: res.data
          });
        });
    });

    this.init();
  }

  getEditData() {
    this.Stats.editSettlementView(this.userSettlement.id, this.canEdit, this.isManagementView).then(res => {
      this.allData = {
        ...res.data.settlementEditView,
        comment: res.data.settlementEditView.commentBeforeEdit,
        cumulatedOvertime: moment.duration(res.data.settlementEditView.cumulatedOvertime),
        date: res.data.settlementEditView.dateBeforeEdit,
      };
      this.cumulatedOvertimeToShow = this.$filter("hms")(this.allData.cumulatedOvertime.toJSON());

      const settles = res.data.settlementEditView.settles.map((x) => {
        return {
          ...x,
          settledOvertimeToShow: this.$filter("hms")(moment.duration(x.settledOvertimeBeforeEdit).toJSON()),
          settledOvertime: moment.duration(x.settledOvertimeBeforeEdit),
          overtimeAlreadyUsed: x.overtimeAlreadyUsed,
          acceptedOvertime: x.acceptedOvertime,
        };
      }).sort((a, b) => new Date(b.acceptedOvertimeDate) - new Date(a.acceptedOvertimeDate));

      let settlesPreviousYears = {
        ...res.data.settlementEditView.settlePreviousYears,
        workTime: "",
        worknorm: {
          worknorm: ""
        },
        overtimeAlreadyUsed: res.data.settlementEditView.settlePreviousYears.overtimeAlreadyUsed,
        acceptedOvertime: res.data.settlementEditView.settlePreviousYears.acceptedOvertime,
        acceptedOvertimeDate: "OVERTIME.CUMULATED_FROM_PREVIOUS_YEARS",
        settledOvertimeToShow: this.$filter("hms")(moment.duration(this.allData.settlePreviousYears.settledOvertimeBeforeEdit).toJSON()),
        settledOvertime: moment.duration(this.allData.settlePreviousYears.settledOvertimeBeforeEdit)
      };

      settles.push(settlesPreviousYears);
      this.settlesObjects = settles.reverse();
      this.displayedObjects = angular.copy(this.settlesObjects);
      this.state = "loaded";
    }, () => {
      this.state = "error";
    });
  }

  setupData(data) {
    this.employee = data.employeeData.employeeData;
    this.init();
  }

  closeModal() {
    this.$rootScope.reloadCreateSettleView = true;
    this.showModal = false;
  }


  saveSettlementButton(allData) {
    if (!this.overtimeApplication && allData.date === undefined) {
      this.showErrorDate = true;
    } else {
      this.showErrorDate = false;

      if (this.overtimeApplication)
        this.saveOvertimeApplicationSettlement();
      else
        this.userSettlement ? this.saveEditSettlement() : this.saveSettlement(allData);
    }
  }

  updateDate(date) {
    if (date === undefined) {
      this.showErrorDate = true;
    } else {
      this.showErrorDate = false;
    }
  }

  saveSettlement(allData) {
    let settleFromPreviousYears = this.displayedObjects.filter(x => {
      if (x.acceptedOvertimeDate === "OVERTIME.CUMULATED_FROM_PREVIOUS_YEARS") {
        return x;
      }
    })[0];

    let settles = this.displayedObjects.filter(x => {
      if (x.acceptedOvertimeDate !== "OVERTIME.CUMULATED_FROM_PREVIOUS_YEARS") {
        x.settledOvertime = moment.duration(x.settledOvertime).toJSON();
        return x;
      }
    });

    const saveObject = {
      date: allData.date,
      settles: settles,
      comment: allData.comment,
      settleFromPreviousYears: moment.duration(settleFromPreviousYears.settledOvertime).toJSON()
    };

    this.Stats.saveSettlement(this.employee.id, saveObject, this.isManagementView).then(() => {
      this.closeModal();
      this.Notes.postNote({
        type: "success",
        message: this.$translate.instant("VIEW360.MODAL.SUCCESS_SAVED")
      });
    }, (res) => {
      this.modalConfig = {
        text: res.data.message,
        acceptText: this.$translate.instant("OK"),
        cancelText: "",
        hideLeftButton: "hide"
      };

      this.bModal.show(this.modalConfig).then(() => {
      }, (res) => {
        this.Notes.postNote({
          type: "error",
          message: res.data
        });
      });
    }, angular.noop);

    this.init();
  }

  checkOnBlur() {
    if (this.fifoValue === '0') {
      this.fifoValue = "00:00:00";
      this.fifoValueToShow = "00:00:00";
      this.durationInvalidFifo = false;
    }
    if(!this.overtimeApplication && moment.duration(this.fifoValueToShow) > moment.duration(this.allData.cumulatedOvertime) || 
    (this.fifoValueToShow === this.cumulatedOvertimeToShow)) {
      this.fifoValue = this.allData.cumulatedOvertime;
      this.changedFifoValue = false;
      this.fifoValueToShow = this.$filter("hms")(this.allData.cumulatedOvertime.toJSON());
   }
  }

  inputChangeFifo() {
      let format = /^-?(\d+):(?:[012345]\d):(?:[012345]\d)/;
      let match = this.fifoValueToShow.match(format);
      
      this.changedFifoValue = true;
   
      if (match) {
        this.durationInvalidFifo = false;
      }
      else { this.durationInvalidFifo = true; }
  }

  inputBlur(settlesObject) {
    if (settlesObject.settledOvertimeToShow === '0') {
      settlesObject.settledOvertimeToShow = "00:00:00";
      settlesObject.settledOvertime = "00:00:00";
      settlesObject.durationInvalid = false;
    }
  }

  inputChange(settlesObject) {
    let format = /^-?(\d+):(?:[012345]\d):(?:[012345]\d)/;
    let match = settlesObject.settledOvertimeToShow.match(format);

    if (match) {
      settlesObject.durationInvalid = false;
      settlesObject.settledOvertime = settlesObject.settledOvertimeToShow;
    }
    else { settlesObject.durationInvalid = true; }
  }

  useFifo(value) {
    let all = moment.duration(this.changedFifoValue ? this.fifoValueToShow : this.fifoValue).asMilliseconds();
    this.settlesObjects
      .filter(settleObject => !this.overtimeApplication
        ? true
        : moment(settleObject.date).isBetween(this.from, this.to, undefined, '[]')
      ).map(element => {
        if (value === 0 ||this.useFifoIsFullyUsed) {
          element.settledOvertime = "00:00:00";
          element.settledOvertimeToShow = "00:00:00";
        }
        else if (this.overtimeApplication) {
          if (moment.duration(element.reportedOvertime) < 0) {
            const div = all + moment.duration(element.reportedOvertime);
            if (div < 0 && div !== all && all > 0) {
              element.settledOvertime = moment.duration(all);
              element.settledOvertimeToShow = this.$filter("hms")(moment.duration(all).toJSON());
              all = 0;
            } else if (all > 0 && div !== all) {
              const revertedTime = moment.duration(element.reportedOvertime).asMilliseconds() * -1;
              element.settledOvertime = moment.duration(revertedTime);
              element.settledOvertimeToShow = this.$filter("hms")(moment.duration(revertedTime).toJSON());
              all += moment.duration(element.reportedOvertime).asMilliseconds();
            }
          }
        }
        else {
          let div = moment.duration(element.acceptedOvertime) - moment.duration(element.overtimeAlreadyUsed);
          if (div > 0 && div <= all) {
            element.settledOvertime = moment.duration(div);
            element.settledOvertimeToShow = this.$filter("hms")(moment.duration(div).toJSON());
            all -= div;
          }
          else if (div > all && all > 0) {
            element.settledOvertime = moment.duration(all);
            element.settledOvertimeToShow = this.$filter("hms")(moment.duration(all).toJSON());
            all = 0;
          }
        }
      });

    if (value === 0 || this.useFifoIsFullyUsed) {
      if (this.overtimeApplication) {
        this.useFifoIsFullyUsed = false;
        this.fifoValue = this.items.length > 0
        ? this.items.reduce(
          (accumulator, current) => accumulator.subtract(moment.duration(current.settledOvertime)),
          moment.duration(this.employeeData.reportedDuration)
        )
        : moment.duration(this.employeeData.reportedDuration);

      this.fifoValueToShow = this.$filter("hms")(this.fifoValue.toJSON());
      } else {
        this.fifoValue = moment.duration(this.allData.cumulatedOvertime);
        this.fifoValueToShow = this.$filter("hms")(this.allData.cumulatedOvertime.toJSON());
      }
    } else {
      if (this.overtimeApplication) {
        this.fifoValue = moment.duration(all);
        this.fifoValueToShow = this.$filter("hms")(this.fifoValue.toJSON());
        this.useFifoIsFullyUsed = true;
      } else {
        this.fifoValue = 0;
        this.fifoValueToShow = 0;
      }
    }

    this.sort = {
      field: 'acceptedOvertimeDate',
      direction: 'asc'
    };
    this.sortTable();
  }

  sortByDate(objects, direction) {
    const multiplier = direction === 'desc' ? 1 : -1;
    return objects.sort((a, b) => {
      if (a.acceptedOvertimeDate === 'OVERTIME.CUMULATED_FROM_PREVIOUS_YEARS')
        return -1;
      else if ((b.acceptedOvertimeDate === 'OVERTIME.CUMULATED_FROM_PREVIOUS_YEARS'))
        return 1;
      else {
        return (new Date(b.acceptedOvertimeDate) - new Date(a.acceptedOvertimeDate)) * multiplier;
      }
    });
  }

  sortByTime(objects, field, direction) {
    return objects.sort((a, b) => {
      const multiplier = direction === 'desc' ? 1 : -1;
      const valueA = field === 'worknorm' ? a.worknorm.worknorm : a[field];
      const valueB = field === 'worknorm' ? b.worknorm.worknorm : b[field];

      if (a.acceptedOvertimeDate === 'OVERTIME.CUMULATED_FROM_PREVIOUS_YEARS')
        return -1;
      else if ((b.acceptedOvertimeDate === 'OVERTIME.CUMULATED_FROM_PREVIOUS_YEARS'))
        return 1;
      else {
        return (moment.duration(valueB).asMilliseconds() - moment.duration(valueA).asMilliseconds()) * multiplier;
      }
    });
  }

  sortTable(field) { 
    if (field) {
      if (this.sort.field !== field) {
        this.sort.field = field;
        this.sort.direction = 'asc';
      } else {
        if (this.sort.direction === 'asc') {
          this.sort.direction = 'desc';
        } else if (this.sort.direction === 'desc') {
          this.sort = {};
        }
      }
    }

    const settlesObjects = this.employeeData.applicationCode
      ? angular
          .copy(this.settlesObjects)
          .filter(settleObject => moment(settleObject.date).isBetween(this.from, this.to, undefined, '[]'))
      : angular.copy(this.settlesObjects);

    if (!this.sort.field) {
      this.displayedObjects = settlesObjects;
    } else {
      this.displayedObjects = this.sort.field === 'acceptedOvertimeDate'
        ? this.sortByDate(settlesObjects, this.sort.direction)
        : this.sortByTime(settlesObjects, this.sort.field, this.sort.direction);
    }
  }

  changeDateRange() {
    this.displayedObjects = angular
      .copy(this.settlesObjects)
      .filter(settleObject => moment(settleObject.date).isBetween(this.from, this.to, undefined, '[]'));
    this.useFifo(0);
    this.useFifoDisabled = this.isNotWorknormBased
      || this.displayedObjects.every(settleObject => moment.duration(settleObject.reportedOvertime).add(moment.duration(settleObject.alreadyFilled)) >= 0);
  }

  noOvertimeToUse() {
    return this.displayedObjects.every(displayedObject => displayedObject.settledOvertimeToShow === "00:00:00");
  }
}
